/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/ban-types */
import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ActionsEventsService {
  sendMessageToBot = true;

  messageChatKeyUpSubject: Rx.Subject<string> = new Rx.Subject<string>();
  messageChatEnterSubject: Rx.Subject<string> = new Rx.Subject<string>();
  messageChatToHomePageSubject: Rx.Subject<string> = new Rx.Subject<string>();
  // Esto es para volver el input del chat text o password
  typeInputHomePageSubject: Rx.Subject<string> = new Rx.Subject<string>();
  // message configuration placeholder input home
  textPlaceholderHomePage: Rx.Subject<object> = new Rx.Subject<object>();
  showWrittingLoaderSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  // PARA CAMBIAR EL BRANCH DE LA APLICACION
  changeBrandClassSubject: Rx.Subject<string> = new Rx.Subject<string>();
  // PARA CAMBIAR EL status del usuario (loggeado o no loggeado)
  changeUserIsLoggedSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  // PARA hacer focus al input del chat
  focusChatBoxSubject: Rx.Subject<any> = new Rx.Subject<any>();
  // PARA mostrar el circularLoader del home
  showCircularLoaderSubject: Rx.Subject<any> = new Rx.Subject<any>();
  // PARA CAMBIAR EL CSS DE EL DIV DE LA LLAMADA
  changeSCSSDivContentLPCobrowse: Rx.Subject<string> = new Rx.Subject<string>();
  showClassMiles: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  goBackToMenu: Rx.Subject<any> = new Rx.Subject();
  goBackToLogin: Rx.Subject<any> = new Rx.Subject();
  activateModalLogin: Rx.Subject<any> = new Rx.Subject();
  blurChatBoxSubject: Rx.Subject<any> = new Rx.Subject();
  universalLoadSubject: Rx.Subject<boolean> = new Rx.Subject();
  imageLoguedSucessfull: Rx.Subject<boolean> = new Rx.Subject();
  configurationsMrFooter: Rx.Subject<any> = new Rx.Subject();
  goToPayOnePocket: Rx.Subject<any> = new Rx.Subject();
  infoBankUser: Rx.Subject<any> = new Rx.Subject();
  showChatBoxSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  showFabButtonsSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  isChatingWithBotSubject: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  clearInfoBankUserSubject: Rx.Subject<any> = new Rx.Subject<any>();
  completeCardSelectedOrAdd: Rx.Subject<boolean> = new Rx.Subject<boolean>();
  toExpireSessionSubject: Rx.Subject<any> = new Rx.Subject<any>();
  add_Card: Rx.Subject<any> = new Rx.Subject<any>();
  goToRatingApp: Rx.Subject<any> = new Rx.Subject<any>();
  getCountriesSubject: Rx.Subject<any> = new Rx.Subject<any>();

  constructor() { }

  sendMessageChatKeyUpSubject(sentMessage: string) {
    this.messageChatKeyUpSubject.next(sentMessage);
  }

  sendMessageChatEnterSubject(sentMessage: string) {
    this.messageChatEnterSubject.next(sentMessage);
  }

  sendMessageChatToHomePageSubject(sentMessage: string) {
    this.messageChatToHomePageSubject.next(sentMessage);
  }

  sendTypeInputHomePageSubject(type: string) {
    this.typeInputHomePageSubject.next(type);
  }

  sendTypePlaceholderInputHomePage(type: object) {
    this.textPlaceholderHomePage.next(type);
  }

  showWrittingLoader(showModal: boolean) {
    this.showWrittingLoaderSubject.next(showModal);
  }

  changeBrandClassApp(brandClass: string) {
    this.changeBrandClassSubject.next(brandClass);
  }

  changeUserIsLogged(userIsLogged: boolean) {
    this.changeUserIsLoggedSubject.next(userIsLogged);
  }

  focusChatBox() {
    this.focusChatBoxSubject.next('');
  }

  blurChatBox() {
    this.blurChatBoxSubject.next('');
  }

  showCircularLoader(showLoader:boolean) {
    this.showCircularLoaderSubject.next(showLoader);
  }

  changeClassDivContentLPCobrowse(nameClass: string) {
    this.changeSCSSDivContentLPCobrowse.next(nameClass);
  }

  setClassMilesHeader(showLoader: boolean) {
    this.showClassMiles.next(showLoader);
  }

  backToMenu() {
    this.goBackToMenu.next();
  }

  backToLogin() {
    this.goBackToLogin.next();
  }

  activateModalLoginNext(activated: boolean) {
    this.activateModalLogin.next(activated);
  }

  universalLoad(load: boolean) {
    this.universalLoadSubject.next(load);
  }

  sendUserLoguedMr(isHomeMr: boolean) {
    this.imageLoguedSucessfull.next(isHomeMr);
  }

  changeConfiguratedFooterMr(config) {
    this.configurationsMrFooter.next(config);
  }

  changeInfoBankUser(config) {
    this.infoBankUser.next(config);
  }

  showChatBox(show: boolean) {
    this.showChatBoxSubject.next(show);
  }

  showFabButtons(show: boolean) {
    this.showFabButtonsSubject.next(show);
  }

  isChatingWithBot(isChatingWithBot: boolean) {
    this.isChatingWithBotSubject.next(isChatingWithBot);
  }

  showToPayOnePocket(idPurchase: string) {
    this.goToPayOnePocket.next(idPurchase);
  }

  clearInfoBankUser() {
    this.clearInfoBankUserSubject.next();
  }

  completeSelectedCard(complete: boolean) {
    this.completeCardSelectedOrAdd.next(complete);
  }

  toExpireSession() {
    this.toExpireSessionSubject.next();
  }

  addcard() {
    this.add_Card.next();
  }

  goRatingApp() {
    this.goToRatingApp.next();
  }

  completeCallCountries(countries) {
    this.getCountriesSubject.next(countries);
  }
}
